import React from "react";
import styled from "styled-components";
import gamedevelopmentImage from "../assets/Group 129.png";
import pingimg from "../assets/pngwing 1.png";
import imageleft from "../assets/Group 150.png";
import { IoIosArrowDroprightCircle } from "react-icons/io";
import serviceImage from "../assets/image 67.png";
import serviceImage1 from "../assets/image 68.png";
import serviceImage2 from "../assets/image 69.png";
import serviceImage3 from "../assets/Group 158.png";
import imageuiux from "../assets/UI UX Process.png";
import { useState } from "react";
import Rectangle111 from "../assets/Rectangle 111.png";
import Rectangle112 from "../assets/Rectangle 112.png";
import Rectangle113 from "../assets/Rectangle 113.png";
import Rectangle114 from "../assets/Rectangle 114.png";
import Rectangle115 from "../assets/Rectangle 115.png";
import Rectangle116 from "../assets/Rectangle 116.png";
import Rectangle117 from "../assets/Rectangle 117.png";
import Rectangle118 from "../assets/Rectangle 118.png";
import Rectangle119 from "../assets/Rectangle 119.png";
import Rectangle120 from "../assets/Rectangle 120.png";
import { useNavigate } from "react-router-dom";
import Rectangle001 from "../assets/X1.png";
import Rectangle002 from "../assets/X2.png";
import Rectangle003 from "../assets/X3.png";
import Rectangle004 from "../assets/X4.png";
import Rectangle005 from "../assets/X5.png";
import Rectangle006 from "../assets/X6.png";
import Rectangle007 from "../assets/X7.png";
import Rectangle008 from "../assets/X8.png";
import Rectangle009 from "../assets/X9.png";
import Rectangle010 from "../assets/X10.png";

const MainWrapContanier = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
`;
const MobileAppImage = styled.img`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  object-fit: cover;
  z-index: -1;
  @media (max-width: 600px) {
    width: 100%;
    height: auto;
  }
  @media (min-width: 601px) and (max-width: 1024px) {
    width: 100%;
    height: auto;
  }
`;
const ContanierHead1 = styled.h1`
  color: darkblue;
  font-size: 42px;
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;
  line-height: 1.5;
`;
const ContanierPara7 = styled.p`
  text-align: center;
  justify-content: center;
  margin-left: 175px;
  margin-right: 175px;
  font-size: 23px;
  /* padding:80px; */
  margin-top: 50px;
  margin-bottom: 50px;

  line-height: 2;
`;
const MobileHeadPara = styled.div``;

const MobileAppImage2 = styled.img`
  position: absolute;
  top: 200px;
  left: 100px;
  z-index: 100;
  @media (max-width: 600px) {
    top: 140px;
    left: 50px;
    width: 130px;
    height: 40px;
  }
  @media (min-width: 601px) and (max-width: 1024px) {
    top: 140px;
    left: 50px;
    width: 150px;
    height: 42px;
  }
  @media (min-width: 1025px) and (max-width: 1440px) {
    left: 50px;
    left: 140px;
  }
  @media (min-width: 1441px) and (max-width: 2100px) {
    top: 250px;
    left: 330px;
  }
`;
const FrontHead = styled.h1`
  position: absolute;
  top: 300px;
  color: white;
  text-align: center;
  font-size: 79px;
  left: 100px;
  z-index: 100;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.7); /* Adding shadow effect */

  @media (max-width: 600px) {
    font-size: 20px;
    top: 190px;
    left: 80px;
  }

  @media (min-width: 601px) and (max-width: 1024px) {
    font-size: 25px;
    top: 190px;
    left: 80px;
  }

  @media (min-width: 1441px) and (max-width: 2100px) {
    top: 350px;
    left: 280px;
  }
`;
const MainContanier1 = styled.div`
  width: 100%;
  height: 470px;
  /* background-color: red; */
  justify-content: center;
  align-items: center;

  display: flex;
  box-sizing: border-box;
  padding: 40px;
  @media (max-width: 600px) {
    width: 100%;
    height: auto;
    flex-direction: column;
    padding: 10px;
  }
  @media (max-width: 600px) {
    flex-direction: column-reverse;
  }

  @media (min-width: 601px) and (max-width: 1024px) {
    width: 100%;
    height: auto;
    flex-direction: column;
    padding: 10px;
  }
  @media (min-width: 601px) and (max-width: 1024px) {
    flex-direction: column-reverse;
  }
  @media (min-width: 1025px) and (max-width: 1300px) {
    gap: 0px;
  }
  @media (min-width: 1301px) and (max-width: 1440px) {
    height: 550px;
  }
  @media (min-width: 1441px) and (max-width: 2100px) {
    height: 600px;
  }
`;
const MainContanierChild1 = styled.div`
  width: 60%;
  height: 420px;
  /* background-color: blue; */
  @media (max-width: 600px) {
    width: 100%;
    height: auto;
    font-size: 40px;
    padding-top: 20px;
    text-align: center;
    align-items: center;
    justify-content: center;
    padding-bottom: 20px;
  }
  @media (min-width: 601px) and (max-width: 1024px) {
    width: 100%;
    height: auto;
    font-size: 60px;
    padding-top: 20px;
    padding-bottom: 20px;
    text-align: center;
    align-items: center;
    justify-content: center;
  }
  @media (min-width: 1025px) and (max-width: 1300px) {
    width: 100%;
    height: auto;
    font-size: 60px;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  @media (min-width: 1301px) and (max-width: 1440px) {
    height: 500px;
  }
  @media (min-width: 1441px) and (max-width: 2100px) {
    height: 550px;
    padding-left: 200px;
    line-height: 55px;
    padding-top: 50px;
  }
`;
const MainContanierChild2 = styled.div`
  width: 40%;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 420px;
  /* background-color: #55557a; */
  @media (max-width: 600px) {
    width: 100%;
    height: auto;
    /* padding-right: 60px; */
  }
  @media (min-width: 601px) and (max-width: 1024px) {
    width: 90%;
    height: auto;
  }
  @media (min-width: 1025px) and (max-width: 1300px) {
    width: 70%;
    height: auto;
  }
  @media (min-width: 1301px) and (max-width: 1440px) {
    height: 500px;
  }
  @media (min-width: 1441px) and (max-width: 2100px) {
    height: 550px;
  }
`;
const Heading1 = styled.h1`
  font-size: 45px;

  @media screen and (max-width: 600px) {
    font-size: 20px;
  }
  @media (min-width: 601px) and (max-width: 1024px) {
    font-size: 28px;
  }
`;
const Heading2 = styled.p`
  margin-top: 20px;
  font-size: 25px;
  @media screen and (max-width: 600px) {
    font-size: 20px;
  }
  @media (min-width: 601px) and (max-width: 1024px) {
    font-size: 18px;
  }
`;
const Heading3 = styled.p`
  margin-top: 20px;
  font-size: 16px;
  line-height: 30px;
`;
const DisButton = styled.button`
  border: none;
  align-items: center;
  text-align: center;
  padding: 20px;
  font-size: 18px;
  font-weight: bold;
  border-radius: 50px;
  cursor: pointer;
  margin-top: 30px;
  margin-left: 20px;
  background-color: #2020cf;
  color: white;
`;
const ImageLeft = styled.img`
  width: 391px;
  height: 352;
  margin: 20px;
  @media (max-width: 600px) {
    height: auto;
  }
  @media (min-width: 1301px) and (max-width: 1440px) {
    height: auto;
  }
  @media (min-width: 1441px) and (max-width: 2100px) {
    width: 75%;
    height: auto;
  }
`;

const IoIosArrowDr = styled(IoIosArrowDroprightCircle)`
  margin-right: 10px;
`;
const Container19 = styled.div`
  /* background-color: yellow; */
  position: relative;
  margin-top: 10px;
  width: 100%;
  text-align: center;
  justify-content: center;
  align-items: center;
  z-index: 1;
  box-sizing: border-box;
  height: 585px;
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;

  @media screen and (max-width: 600px) {
    width: 100%;
    max-width: 99%;
    height: auto;
    height: 2200px;
  }
  @media (min-width: 601px) and (max-width: 814px) {
    width: 100%;
    max-width: 99%;
    height: auto;
    height: 970px;
  }
  @media (min-width: 815px) and (max-width: 1107px) {
    width: 100%;
    max-width: 99%;
    height: auto;
    height: 970px;
  }
  @media (min-width: 1108px) and (max-width: 1300px) {
    width: 100%;
    max-width: 99%;
    height: auto;
    height: 600px;
  }
  @media (min-width: 1301px) and (max-width: 1627px) {
    width: 100%;
    max-width: 99%;
    height: auto;
    height: 580px;
  }
  @media (min-width: 1628px) and (max-width: 2100px) {
    width: 100%;
    height: 580px;
  }
`;
const Div = styled.div`
  width: 100%;
  /* background-color: green; */
  height: auto;
  position: relative;
  background-color: green;
  align-items: center;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 600px) {
    width: 100%;
    height: auto;
  }
`;

const Div2 = styled.div`
  width: 100%;
  align-items: center;
  text-align: center;
  justify-content: center;
  /* background-color: yellow; */
  height: auto;
  box-sizing: border-box;
  flex-wrap: wrap;
  display: flex;
  @media (max-width: 600px) {
    flex-direction: flex;
    width: 100%;
    height: auto;
    align-items: center;
    text-align: center;
    justify-content: center;
  }
  @media (min-width: 601px) and (max-width: 1024px) {
    flex-direction: flex;
    width: 100%;
    height: auto;
    align-items: center;
    text-align: center;
    justify-content: center;
  }
  @media (min-width: 1025px) and (max-width: 1300px) {
    flex-direction: flex;
    width: 100%;
    height: auto;
    align-items: center;
    text-align: center;
    justify-content: center;
  }
  @media (min-width: 1441px) and (max-width: 2100px) {
    width: 100%;
    height: auto;
    align-items: center;
    text-align: center;
    justify-content: center;
  }
`;
const PageContainer2 = styled.div`
  position: relative;
  width: 100%;
  height: 445px;
  z-index: 100;
  /* background-color: red; */
  @media screen and (max-width: 430px) {
    display: flex;
    /* overflow: scroll; */
    height: 590px;
    width: 90%;
    margin: 20px;
  }
`;
const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 2rem;
  position: absolute;
  top: 10%;
  /* left: 10%; */
  box-sizing: border-box;
  z-index: 1;
  width: 100%;
  /* background-color: red; */
  @media screen and (max-width: 600px) {
    flex-direction: column;
    width: 100%;
    height: auto;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  @media (min-width: 1301px) and (max-width: 1440px) {
    gap: 4rem;
  }
`;
const Card = styled.div`
  position: relative;
  background-color: white;
  color: black;
  width: 250px;
  height: 350px;
  padding: 1rem;
  border-radius: 25px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  text-align: center;
  opacity: 0.8;
  border: 1px solid black;

  transition: transform 0.3s ease, box-shadow 0.3s ease, opacity 0.3s ease;

  &:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
    opacity: 1;
    cursor: pointer;
    border: solid 2px #1c1c7a;
    background-color: #b6b2b2; /* Background color on hover */
    transform: scale(1.05);
  }

  &:hover img {
    /* Change image color to grayscale on hover */
  }

  &:hover h3 {
    color: #1c1c7a;
  }

  &:hover p {
    color: #1c1c7a;
  }
  @media screen and (max-width: 600px) {
    width: 300px;
    height: 450px;
    /* margin-right:10px; */

    /* margin-left: 20px;
    margin-right:20px; */
  }
`;
const CardDescription = styled.p`
  font-size: 1rem;
  color: black;

  @media screen and (max-width: 600px) {
    align-item: center;
    text-align: center;
    line-height: 22px;
    font-size: 15px;
  }
`;
const CardTitle = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
  @media screen and (max-width: 600px) {
    font-size: 25px;
    align-items: center;
    text-align: center;
  }
`;
const CardImage = styled.img`
  width: auto;
  height: auto;
  object-fit: cover;
  margin-bottom: 1rem;
  color: black;
`;
const PeraWeb = styled.p`
  color: black;
  margin-top: 10px;
  font-size: 25px;
  margin-bottom: 3rem;
  text-align: center;
  box-sizing: border-box;
  @media screen and (max-width: 600px) {
    font-size: 18px;
  }
  @media (min-width: 601px) and (max-width: 1024px) {
    font-size: 20px;
  }
`;

const HeaderWeb = styled.h1`
  color: black;
  margin-top: 30px;
  font-size: 45px;
  margin-bottom: 1rem;
  margin-left: 40px;

  text-align: center;
  @media screen and (max-width: 600px) {
    margin-left: 0%;
    margin-top: 0px;
    font-size: 20px;
  }
  @media (min-width: 601px) and (max-width: 1024px) {
    margin-left: 0%;
    margin-top: 0px;
    font-size: 28px;
  }
  @media (min-width: 1441px) and (max-width: 2100px) {
    margin-left: 100px;
    margin-right: 100px;
  }
`;

const Container20 = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  align-items: center;
  text-align: center;
  justify-content: center;
  /* background-color: red; */
  @media (min-width: 1025px) and (max-width: 1300px) {
    width: 100%;
    height: auto;
  }
`;
const ImageUiUx = styled.img`
  width: 100%;
  align-items: center;
  height: auto;
  padding-left: 60px;
  padding-right: 60px;
  object-fit: cover;
  margin-top: 20px;

  justify-content: center;
  @media screen and (max-width: 600px) {
    margin: 0%;
    width: 100%;
    height: auto;

    margin-top: 30px;
    margin-bottom: 30px;
  }
  @media (min-width: 601px) and (max-width: 1024px) {
    margin: 0%;
    width: 100%;
    height: auto;
    margin-top: 30px;
    margin-bottom: 30px;
  }
  @media (min-width: 601px) and (max-width: 1024px) {
    margin: 0%;
    width: 100%;
    height: auto;
    margin-top: 30px;
    margin-bottom: 30px;
  }
  @media (min-width: 1301px) and (max-width: 1440px) {
    width: 100%;
    align-items: center;
    height: auto;
    object-fit: cover;
  }
  @media (min-width: 1441px) and (max-width: 2100px) {
    width: 100%;
    height: auto;
  }
`;
const Container21 = styled.div`
  width: 100%;

  height: 700px;
  box-sizing: border-box;
  /* background-color:green; */
  justify-content: center;
  align-items: center;
  @media (max-width: 600px) {
    width: 100%;
    height: auto;
  }
  @media (min-width: 601px) and (max-width: 1024px) {
    width: 100%;
    height: auto;
  }
  @media (min-width: 1025px) and (max-width: 1300px) {
    width: 100%;
    height: 800px;
  }
`;
const TabNavigation = styled.div`
  margin-top: 40px;
  width: 90%;
  height: 480px;
  align-items: center;
  text-align: center;
  justify-content: center;
  background-color: #d4d4d4;
  margin-left: 60px;
  @media (max-width: 600px) {
    width: 100%;
    height: auto;

    margin-left: 0%;
  }
  @media (min-width: 601px) and (max-width: 1024px) {
    width: 100%;
    height: auto;

    margin-left: 0%;
  }
  @media (min-width: 1441px) and (max-width: 2100px) {
    align-items: center;
    text-align: center;
    justify-content: center;
    margin-left: 80px;
  }
`;

const Dflex = styled.ul`
  display: flex;
  text-decoration: none;
  gap: 2px;
  /* display: none; */
  list-style-type: none;
  text-align: center;
  align-items: center;
  padding: 3px;
  margin-left: 5px;
  @media (max-width: 600px) {
    margin-left: 0px;
  }
  @media (min-width: 601px) and (max-width: 1024px) {
    margin-left: 0%;
  }
`;
const FlexFill = styled.li`
  text-decoration: none;
  background-color: ${(props) => (props.active ? "#0c0ce7" : "white")};
  color: ${(props) => (props.active ? "white" : "black")};
  /* border: 1px solid black; */
  width: 50%;
  height: 50px;
  /* color:white; */
  text-align: center;
  align-items: center;
  padding-top: 10px;
  font-size: 25px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 5px;
  /* display: none; */
  @media (max-width: 600px) {
    margin-left: 0px;
  }
`;
const TabContents = styled.div`
  /* background-color:pink; */
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  height: auto;
  display: ${(props) => (props.show ? "block" : "none")};
  @media (max-width: 600px) {
    width: 100%;
    height: auto;
  }
  @media (min-width: 601px) and (max-width: 1024px) {
    align-items: center;
    text-align: center;
    justify-content: center;
    width: 100%;
    height: auto;
  }
  @media (min-width: 1025px) and (max-width: 1300px) {
    flex-direction: flex;
    width: 100%;
    height: auto;
    align-items: center;
    text-align: center;
    justify-content: center;
  }
`;
const TabContents1 = styled.div`
  display: ${(props) => (props.show ? "block" : "none")};
`;

const HeadTab1 = styled.h1`
  font-size: 15px;
`;
/* const ParaTab1 = styled.p`` */
/* const ShowConten = styled.div`` */
const CardTools = styled.div`
  width: 150px;
  height: 150px;
  background-color: white;
  margin: 10px;
  margin-left: 70px;
  align-items: center;
  text-align: center;
  margin-top: 40px;
  border-radius: 20px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Added transition for smooth effect */

  &:hover {
    transform: scale(1.05); /* Scale up slightly on hover */
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2); /* Darker shadow on hover */
  }
`;

const CardTools1 = styled.div`
  width: 150px;
  height: 150px;
  background-color: white;
  margin: 10px;
  /* margin-left: 70px; */
  align-items: center;
  text-align: center;
  margin-top: 40px;
  border-radius: 20px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Added transition for smooth effect */

  &:hover {
    transform: scale(1.05); /* Scale up slightly on hover */
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2); /* Darker shadow on hover */
  }

  @media (max-width: 600px) {
    margin: 0%;
    margin: 20px;
    align-items: center;
    text-align: center;
    justify-content: center;
  }
  @media (min-width: 601px) and (max-width: 1024px) {
    margin: 0%;
    margin: 20px;
    align-items: center;
    text-align: center;
    justify-content: center;
  }
  @media (min-width: 1300px) and (max-width: 1440px) {
    margin: 0%;
    margin: 20px;
  }
  @media (min-width: 1441px) and (max-width: 2100px) {
    margin: 0%;
    margin: 25px;
    align-items: center;
    text-align: center;
    justify-content: center;
  }
`;
const TechImage = styled.img`
  width: 100px;
  height: 100px;
  margin-top: 25px;
  align-items: center;
`;
const TechImage1 = styled.img`
  margin-top: 30px;
  text-align: center;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
`;
const TechImage2 = styled.img`
  text-align: center;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
`;

const UiUx = () => {
  const navigation = useNavigate();
  const [toggle, setToggle] = useState(1);

  function updateToggle(id) {
    setToggle(id);
  }

  const cards = [
    {
      title: "Mobile App UI/UX Design",
      description:
        "Build a flawless user interface for your mobile users to provide a seamless experience on their phone screens.Big Heap Tech design mobile apps according to iOS and Android conventions",
      img: serviceImage,
    },
    {
      title: "Web UI/UX Design",
      description:
        "Simplify your technically complex products in cahoots with Big Heap Tech UI/UX development services to grow web traffic through modern design aesthetic and dynamic features.",
      img: serviceImage1,
    },
    {
      title: "UI/UX Design Brand Identity",
      description:
        "Drive brand growth with thorughly researched visual designs for your brand. CTA, ICON, color scheme, or typography - Big Heap Tech is an ideal umbrella term for them",
      img: serviceImage2,
    },
    {
      title: "HCI Design",
      description:
        "Maximize operational efficency and improve productivity through Big Heap Tech research, interviews and persona development to deliver user- friendly HCI designs",
      img: serviceImage3,
    },
  ];
  return (
    <>
      <MainWrapContanier>
        <MobileAppImage src={gamedevelopmentImage} alt="Background" />
        <MobileAppImage2
          data-aos="fade-down"
          data-aos-easing="linear"
          data-aos-duration="1500"
          src={pingimg}
          alt="Background"
        />
        <FrontHead
          data-aos="fade-down"
          data-aos-easing="linear"
          data-aos-duration="1500"
        >
          UI/UX<br></br>DESIGN
        </FrontHead>

        <MainContanier1>
          <MainContanierChild1>
            <Heading1>
              TOP UI/UX DESIGN<br></br>Services
            </Heading1>
            <Heading2>
              Solve the pressing product design challenges with Big Heap Tech
              UI/UX and design wizards
            </Heading2>
            <Heading3>
              <IoIosArrowDr />
              increase your product adoption by creating a seamless
              user-friendly design.<br></br>
              <IoIosArrowDr />
              invest in user interface design for higher conversion rates and
              increased revenue.<br></br>
              <IoIosArrowDr />
              Boost customer retention by developing fit-for-purpose UI/UX
              design.
            </Heading3>
            <DisButton onClick={() => navigation("/ContactUs")}>
              Discus Your Project
            </DisButton>
          </MainContanierChild1>
          <MainContanierChild2>
            <ImageLeft src={imageleft} alt="not found" />
          </MainContanierChild2>
        </MainContanier1>

        <Container19>
          <HeaderWeb data-aos="fade-right">UI/UX DESIGN SERVICES</HeaderWeb>
          <PeraWeb data-aos="fade-right">
            Big Heap Tech exclusive UI/UX designing services are the ultimate
            boosters that turn concepts into functional products.<br></br> Just
            share your idea with us and we have got you covered.{" "}
          </PeraWeb>
          <Div>
            <CardContainer>
              {cards.map((card, index) => (
                <Card
                  data-aos="flip-left"
                  data-aos-easing="ease-out-cubic"
                  data-aos-duration="2000"
                  key={index}
                >
                  <CardImage src={card.img} alt={card.title} />
                  <CardTitle>{card.title}</CardTitle>
                  <CardDescription>{card.description}</CardDescription>
                </Card>
              ))}
            </CardContainer>
          </Div>
        </Container19>

        <Container20>
          <HeaderWeb data-aos="fade-right">
            Kicktart your Project with Big Heap Tech Reliable UI/UX Process
          </HeaderWeb>
          <PeraWeb data-aos="fade-right">
            Big your project journey with Big Heap Tech UI/UX process. We follow
            a straightforward <br></br>procedure to ensure efficent progress{" "}
          </PeraWeb>

          <ImageUiUx src={imageuiux} alt="NOT FOUND" />
        </Container20>

        <Container21>
          <HeaderWeb data-aos="fade-right">
            {" "}
            UI/UX Designing Tools and Technologies
          </HeaderWeb>
          <PeraWeb data-aos="fade-right">
            With our top technologies, your seccess is guaranteed{" "}
          </PeraWeb>

          <TabNavigation>
            <Dflex>
              <FlexFill onClick={() => updateToggle(1)} active={toggle === 1}>
                Tools
              </FlexFill>
              <FlexFill onClick={() => updateToggle(2)} active={toggle === 2}>
                Technologies
              </FlexFill>
            </Dflex>

            <TabContents show={toggle === 1}>
              <Div2>
                <CardTools1>
                  <TechImage1 src={Rectangle001} alt="Image Not fOUND" />
                  <HeadTab1>Sketch</HeadTab1>
                </CardTools1>
                <CardTools1>
                  <TechImage1 src={Rectangle002} alt="Image Not fOUND" />
                  <HeadTab1>Figma</HeadTab1>
                </CardTools1>
                <CardTools1>
                  <TechImage1 src={Rectangle003} alt="Image Not fOUND" />
                  <HeadTab1>Craft</HeadTab1>
                </CardTools1>
                <CardTools1>
                  <TechImage1 src={Rectangle004} alt="Image Not fOUND" />
                  <HeadTab1>
                    Adobe <br></br>Photoshope
                  </HeadTab1>
                </CardTools1>
                <CardTools1>
                  <TechImage1 src={Rectangle005} alt="Image Not fOUND" />
                  <HeadTab1>
                    Adobe <br></br>Illustrator
                  </HeadTab1>
                </CardTools1>

                <CardTools1>
                  <TechImage1 src={Rectangle006} alt="Image Not fOUND" />
                  <HeadTab1>Proto.io</HeadTab1>
                </CardTools1>
                <CardTools1>
                  <TechImage1 src={Rectangle007} alt="Image Not fOUND" />
                  <HeadTab1>Axure</HeadTab1>
                </CardTools1>
                <CardTools1>
                  <TechImage1 src={Rectangle008} alt="Image Not fOUND" />
                  <HeadTab1>CoralDRAW</HeadTab1>
                </CardTools1>
                <CardTools1>
                  <TechImage1 src={Rectangle009} alt="Image Not fOUND" />
                  <HeadTab1>InVision Studio</HeadTab1>
                </CardTools1>
                <CardTools1>
                  <TechImage1 src={Rectangle010} alt="Image Not fOUND" />
                  <HeadTab1>Adobe XD</HeadTab1>
                </CardTools1>
              </Div2>
            </TabContents>

            <TabContents show={toggle === 2}>
              <Div2>
                <CardTools1>
                  <TechImage2 src={Rectangle111} alt="Image Not fOUND" />
                </CardTools1>
                <CardTools1>
                  <TechImage2 src={Rectangle112} alt="Image Not fOUND" />
                </CardTools1>
                <CardTools1>
                  <TechImage2 src={Rectangle113} alt="Image Not fOUND" />
                </CardTools1>
                <CardTools1>
                  <TechImage2 src={Rectangle114} alt="Image Not fOUND" />
                </CardTools1>
                <CardTools1>
                  <TechImage2 src={Rectangle115} alt="Image Not fOUND" />
                </CardTools1>

                <CardTools1>
                  <TechImage2 src={Rectangle116} alt="Image Not fOUND" />
                </CardTools1>
                <CardTools1>
                  <TechImage2 src={Rectangle117} alt="Image Not fOUND" />
                </CardTools1>
                <CardTools1>
                  <TechImage2 src={Rectangle118} alt="Image Not fOUND" />
                </CardTools1>
                <CardTools1>
                  <TechImage2 src={Rectangle119} alt="Image Not fOUND" />
                </CardTools1>
                <CardTools1>
                  <TechImage2 src={Rectangle120} alt="Image Not fOUND" />
                </CardTools1>
              </Div2>
            </TabContents>
          </TabNavigation>
        </Container21>
      </MainWrapContanier>
    </>
  );
};

export default UiUx;
